/* eslint-disable max-len */
module.exports = {
  privacy: {
    head: "Gizlilik Politikası",
    datechange: "Son güncelleme tarihi: 2022-12-30",
    blocks: [
      {
        title: "Giriş",
        href: "#ref1",
        text: `
          <strong>smartteam.dev ziyaretçilerinin gizliliği bizim için büyük önem taşır.</strong>
          Bu politika, smartteam.dev tarafından hangi kişisel verilerin toplandığını ve bu verilerin nasıl kullanıldığını açıklar.
        `
      },
      {
        title: "Hangi kişisel verileri topluyoruz",
        href: "#ref2",
        text: `
          Topladığımız bilgiler iki ana gruba ayrılır:<br>
          1) Kimliği belirlenebilir kişisel bilgiler: Sipariş verme, form doldurma (ör. geri bildirim formu), kayıt olma, e-posta veya telefon paylaşma gibi kullanıcı tarafından gönüllü olarak sağlanan bilgiler.<br>
          2) Kimliği belirlenemeyen bilgiler: Site gezinimi sırasında toplanan teknik/istatistiksel izleme verileri.
        `
      },
      {
        title: "Kişisel verileri nasıl kullanıyoruz",
        href: "#ref3",
        text: `
          Kişisel verileri, talep ettiğiniz yayın ve hizmetleri sunmak veya yürürlükteki mevzuattan doğan yükümlülükleri yerine getirmek için toplarız.
          Veri toplama amacı, verinin alındığı anda açıklanır veya bağlamdan açıkça anlaşılır.
        `
      },
      {
        title: "Veri güvenliği",
        href: "#ref4",
        text: `
          smartteam.dev; topladığı, kullandığı veya aktardığı bilgilerin doğru, güncel, tam olmasını ve yalnızca yetkili kişilerin erişebileceği güvenli ortamlarda saklanmasını sağlamak için makul önlemler alır.
          Bununla birlikte, üçüncü tarafların yetkisiz erişimine karşı mutlak garanti verilemez.
        `
      },
      {
        title: "Log dosyaları",
        href: "#ref5",
        text: `
          Birçok web sitesi gibi smartteam.dev da log dosyaları kullanır.
          Bu loglarda IP adresi, tarayıcı türü, internet servis sağlayıcısı, tarih/saat bilgisi, giriş-çıkış sayfaları ve tıklama verileri bulunabilir.
          Bu veriler; eğilim analizi, site yönetimi ve kullanım istatistikleri için kullanılır; kimliği belirleyen bilgilerle doğrudan eşleştirilmez.
        `
      },
      {
        title: "Üçüncü taraf web siteleri",
        href: "#ref6",
        text: `
          Bu web sitesi üçüncü taraf sitelere bağlantılar içerebilir.
          Bu sitelerin içeriklerinden veya kişisel verileri toplama, saklama, kullanma ve paylaşma biçimlerinden sorumlu değiliz.
          Üçüncü taraf bir siteyi ziyaret ettiğinizde ilgili sitenin gizlilik politikasını incelemenizi öneririz.
        `
      },
      {
        title: "Gizlilik politikasındaki değişiklikler",
        href: "#ref7",
        text: `
          Bu gizlilik politikasını önceden bildirimde bulunmaksızın güncelleme hakkımız saklıdır.
          Değişiklikler sitede yayımlandığı anda yürürlüğe girer.
          Güncellemeleri düzenli olarak kontrol etmenizi öneririz.
          Değişiklik sonrası site kullanımının devamı, güncellenmiş politikayı kabul ettiğiniz anlamına gelir.
        `
      },
      {
        title: "Çerez Politikası",
        href: "#ref8",
        text: `
          <span class='txt-blue'>ÖNEMLİ UYARI: LÜTFEN BU SİTEYİ KULLANMADAN ÖNCE DİKKATLE OKUYUN.</span><br>
          Bu bölüm, sitede çerezlerin nasıl kullanıldığını açıklar.
          Politika zaman zaman güncellenebilir ve güncelleme tarihi bu sayfada belirtilir.
          Siteyi kullanarak, bu politika kapsamında çerez kullanımını kabul etmiş olursunuz.
          Çerezleri kabul etmiyorsanız tarayıcınızda devre dışı bırakabilir veya siteyi kullanmayabilirsiniz.
        `
      },
      {
        title: "Çerez nedir",
        href: "#ref9",
        text: `
          Çerez, bir web sitesinin tarayıcınız aracılığıyla cihazınıza kaydettiği küçük metin verisidir.
          Sitenin sizi tanımasına, ziyaretleriniz sırasında tercihlerinizi ve bazı kullanım bilgilerini hatırlamasına yardımcı olur.
        `
      },
      {
        title: "Çerez türleri",
        href: "#ref10",
        text: `
          <strong>Temel olarak iki çerez türü vardır:</strong><br>
          <strong>Oturum çerezleri:</strong> Tarayıcı oturumu sona erdiğinde silinen geçici çerezlerdir.<br>
          <strong>Kalıcı çerezler:</strong> Silinene veya süresi dolana kadar cihazda kalan çerezlerdir; tercihlerinizi hatırlamaya yardımcı olur.
        `
      },
      {
        title: "Çerezleri kullanım amacımız",
        href: "#ref11",
        text: `
          Sitede oturum ve kalıcı çerezleri güvenlik, performans ve kullanıcı deneyimini iyileştirme amacıyla kullanıyoruz.
          Ayrıca anonim istatistiksel analiz için üçüncü taraf hizmetler (ör. Google Analytics) kullanılabilir.
          Tarayıcı ayarları üzerinden hem birinci taraf hem de üçüncü taraf çerezleri engelleyebilirsiniz.
          Çerezler aracılığıyla elde edilen kişisel veriler, gizlilik politikamıza uygun şekilde korunur.
        `
      },
      {
        title: "Bu sitede çerezleri reddetme",
        href: "#ref12",
        text: `
          Çoğu tarayıcı varsayılan olarak çerezleri kabul eder; ancak ayarlar bölümünden bunu değiştirebilirsiniz.
          İsterseniz belirli çerezleri kabul edecek şekilde yapılandırabilir veya her yeni çerez için onay isteyebilirsiniz.
          Tarayıcınızın “Yardım” bölümü, çerez yönetimi konusunda size rehberlik edebilir.
        `
      },
      {
        title: "Ek bilgi",
        href: "#ref13",
        text: `<strong>Bu Gizlilik Politikası hakkında sorularınız için: mail@smartteam.dev</strong>`
      }
    ]
  }
};
/* eslint-enable max-len */
